var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center vh-100"},[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("🚧 Maintenance Mode")]),_c('p',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }